import axios from 'axios';
import router from '../../router';
import config from '../../config';

const state = {
  sid: window.localStorage.getItem('sid'),
  role: window.localStorage.getItem('role'),
  roleId: window.localStorage.getItem('roleId'),
  error: null,
  username: window.localStorage.getItem('username')
};
const getters = {
  sid: state => state.sid,
  role: state => state.role,
  roleId: state => state.roleId,
  error: state => state.error,
  username: state => state.username,
  isAuthenticated: state => !!state.sid
};
const actions = {
  async auth({ commit }, { username, password }) {
    try {
      const response = await axios.get(config.authUrl, {
        params: { username, password }
      });
      const { sid, role, roleId } = response.data.response;

      window.localStorage.setItem('sid', sid);
      window.localStorage.setItem('role', role);
      window.localStorage.setItem('roleId', roleId);
      window.localStorage.setItem('username', username);

      commit('setSid', sid);
      commit('setRole', role);
      commit('setRoleId', roleId);
      commit('setError', null);
      commit('setUsername', username);
    } catch (error) {
      window.localStorage.removeItem('sid');
      window.localStorage.removeItem('role');
      window.localStorage.removeItem('roleId');
      window.localStorage.removeItem('username');
      commit('setSid', null)
      commit('setError', 'Ваша попытка входа не удалась, попробуйте еще раз.');
    }
  },
  async logout({ commit }) {
    window.localStorage.removeItem('sid');
    window.localStorage.removeItem('role');
    window.localStorage.removeItem('roleId');
    window.localStorage.removeItem('username');

    commit('setSid', null);
    commit('setRole', null);
    commit('setRoleId', null);
    commit('setError', null);
    commit('setUsername', null);

    router.replace('/login');
  }
};
const mutations = {
  setSid(state, sid) {
    state.sid = sid;
  },
  setRole(state, role) {
    if (!['club', 'manager', 'owner', 'dealer', null].includes(role)) {
      throw new Error(`role ${role} currently not supported`);
    }
    state.role = role;
  },
  setRoleId(state, roleId) {
    state.roleId = roleId;
  },
  setError(state, error) {
    state.error = error;
  },
  setUsername(state, username) {
    state.username = username;
  }
};
export default { state, getters, actions, mutations };
